import { Button, Typography } from 'antd';
import React from 'react';
import { UseFormReturn } from 'react-hook-form';

import FormIdentitfy from './FormIdentitfy';

import { TableForm } from '.';

interface Step1Props {
  method: UseFormReturn<TableForm>;
  handleClick: () => void;
  isLoading: boolean;
  messageCheckId: string;
}
const Step1: React.FC<Step1Props> = ({
  method, handleClick, isLoading, messageCheckId
}) => (
  <div className="p-home__step1">
    <FormIdentitfy method={method} onHandlePressEnter={handleClick} />
    {
      messageCheckId && (
        <Typography.Text type="danger" style={{ display: 'block', marginTop: 6 }}>
          {messageCheckId}
        </Typography.Text>
      )
    }
    <div className="p-home__step2_btnWrap">
      <Button
        onClick={handleClick}
        className="p-home__step1__btn"
        type="primary"
        disabled={isLoading}
      >
        Kiểm tra
      </Button>
    </div>
  </div>
);

export default Step1;
